import Vue from 'vue'
import underscore from 'vue-underscore'
import App from './App.vue'
import router from './router'
import store from './store/store'
import VueMoment from 'vue-moment'
import vuetify from './plugins/vuetify'
import GetTextPlugin from 'vue-gettext'
import translations from './translations/translations.json'
import vuexI18n from 'vuex-i18n'
import ua from '@/assets/cpv_ua.json'
import en from '@/assets/cpv_en.json'
import country_ua from '@/assets/country_ua.json'
import country_en from '@/assets/country_en.json'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import Vuetify from 'vuetify'
import Amplify from 'aws-amplify'
import awsConfig from './aws_config'
import ErrorMessages from '@/components/ui/ErrorMessages'

import Filter from './filters/filters'

// Sentry
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

Sentry.init({
  dsn: 'https://3163fc7c04c64de9bc8e435aadb68053@stage-demo.openprocurement.io/sentry/7', // todo: do not hardcode
  integrations: [new VueIntegration({ Vue, attachProps: true, logErrors: true })],
  environment: 'stage',
  release: 'fd5a608af2ac156e770afcd8e979e8aada3d67dc',
  beforeSend(event) {
    if (event.exception) {
      Sentry.showReportDialog({ eventId: event.event_id });
    }
    return event;
  }
})
//Sentry end

//execute function to enable all my filters
Filter()

Vue.component('ErrorMessages', ErrorMessages)

Amplify.configure(awsConfig)

Vue.use(underscore)
Vue.use(Vuetify)
Vue.use(VueMoment)

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyBeZtGTpowaqxFl1gQOrY_BPrKeqrawcnw',
})

Vue.config.productionTip = false

Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: 'English',
    ua: 'Ukrainian',
  },
  languageVmMixin: {
    computed: {
      currentKebabCase: function () {
        return this.current.toLowerCase().replace('_', '-')
      },
    },
  },
  translations: translations,
  silent: true,
})

Vue.use(vuexI18n.plugin, store)
Vue.i18n.add('en', { cpv: en, country: country_en })
Vue.i18n.add('ua', { cpv: ua, country: country_ua })
Vue.i18n.set('en')

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
